import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { Globe, ShieldCheck, Clock } from 'lucide-react';
import { fireAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const [selectedBumps, setSelectedBumps] = useState<Record<number, boolean>>({});
  const orderBumps = [{
    title: '🎲 Diversión: +100 juegos y dinámicas para niños y adultos para tu Fiesta',
    price: 5.99,
    strike: '11,99€',
    variantId: '57086730830155',
    image: 'https://cdn.magicpatterns.com/uploads/9FscUW2tjtF97GHJNPbaaB/1-Diversion_Garantizada_en_tu_Fiesta_2B100_juegos_y_dinamicas_para_ninos_y_adultos.png',
    desc: 'Transforma cualquier reunión en una experiencia inolvidable con +100 actividades y juegos para todas las edades. Risas, conexión y recuerdos que tus invitados nunca olvidarán.'
  }, {
    title: '+400 Invitaciones Digitales',
    price: 4.99,
    strike: '9,99€',
    variantId: '57086747803979',
    image: 'https://cdn.magicpatterns.com/uploads/kLJnrKqn3jkiqmmfbTzZBi/2-400_Invitaciones_Digitales_💌_para_toda_ocasion.png',
    desc: 'Despliega un universo de +400 invitaciones digitales para cumpleaños, bodas, baby showers y más. Totalmente editables y listas en minutos para impresionar a tus invitados desde el primer clic.'
  }, {
    title: 'Todo en un Súper Pack',
    price: 9.99,
    strike: '19,99€',
    variantId: '57086777557323',
    image: 'https://cdn.magicpatterns.com/uploads/xyoJ7TrjKZFsjifx8Rm3qc/3-Todo_en_un_superpack.png',
    desc: 'Incluye los 3 complementos anteriores (sublimación, invitaciones digitales y juegos) MÁS: curso de Silhouette Studio, +200 recuerdos editables en Canva y bono especial Día de las Madres. ¡La opción más completa!',
    recommended: true
  }, {
    title: 'Más Creatividad con Sublimación',
    price: 4.99,
    strike: '9,99€',
    variantId: '57086784471371',
    image: 'https://cdn.magicpatterns.com/uploads/tdj9Fk1ZUSj9WGFmKzxsFq/4-Mas_Creatividad_con_Sublimacion_2B850_fondos_y_plantillas.png',
    desc: 'Perfecto para personalizar recuerdos y comenzar a emprender en sublimación.'
  }];
  const toggleBump = (index: number) => {
    setSelectedBumps(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  const basePrice = 15.99;
  const bumpsTotal = orderBumps.reduce((acc, bump, idx) => acc + (selectedBumps[idx] ? bump.price : 0), 0);
  const finalTotal = basePrice + bumpsTotal;
  // Build dynamic Shopify cart URL based on selected bumps
  // Always include base product + any selected bumps
  const cartItems = ['56993529299275:1'];
  orderBumps.forEach((bump, idx) => {
    if (selectedBumps[idx]) {
      cartItems.push(`${bump.variantId}:1`);
    }
  });
  const checkoutUrl = `https://librodigitall.com/cart/${cartItems.join(',')}`;
  return <Section className="bg-partyPink-light relative overflow-hidden" id="pricing" data-id="element-151">
      {/* Background Confetti */}
      <div className="absolute inset-0 opacity-30 pointer-events-none" data-id="element-152">
        {[...Array(20)].map((_, i) => <div key={i} className={`absolute w-3 h-3 rounded-full ${i % 2 === 0 ? 'bg-mint-dark' : i % 3 === 0 ? 'bg-coral' : 'bg-yellow-400'}`} style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        transform: `scale(${Math.random() + 0.5})`
      }} data-id="element-153" />)}
      </div>

      <div className="max-w-3xl mx-auto bg-white rounded-[3rem] p-8 md:p-12 shadow-xl border-8 border-white relative z-10 text-center" data-id="element-154">
        <div className="mb-6" data-id="element-155">
          <h2 className="text-2xl md:text-3xl font-black text-partyPink-hot uppercase tracking-widest mb-2" data-id="element-156">
            Todo el Kit Fiesta Mágica
          </h2>
          <div className="inline-block bg-yellow-party text-gray-800 font-bold px-4 py-1 rounded-full text-lg transform rotate-2" data-id="element-157">
            + 10 BONOS EXCLUSIVOS
          </div>
        </div>

        {/* Mockup Image */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-lg" data-id="element-158">
          <img src="https://cdn.magicpatterns.com/uploads/6xCfR4aVRm3Su9KNjJRJ2Y/Mockup.png" alt="Kit Fiesta Mágica - +1000 Diseños, Imprimir, Recortar, Decorar" className="w-full h-auto object-cover" data-id="element-159" />
        </div>

        <div className="flex items-center justify-center gap-2 mb-6 text-mint-dark font-script text-2xl md:text-3xl" data-id="element-160">
          <Globe className="w-8 h-8" data-id="element-161" />
          <span data-id="element-162">Paga en tu moneda local</span>
        </div>

        <motion.div animate={{
        scale: [1, 1.05, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="mb-6" data-id="element-163">
          <h3 className="text-5xl md:text-7xl font-black text-coral uppercase leading-none drop-shadow-sm" data-id="element-164">
            ¡Solo Hoy
            <br data-id="element-165" />
            60% OFF!
          </h3>
        </motion.div>

        <div className="flex justify-center mb-6" data-id="element-166">
          <div className="bg-partyPink-hot text-white font-bold px-6 py-2 rounded-lg text-xl uppercase tracking-wider shadow-md transform -rotate-2" data-id="element-167">
            Descarga Inmediata
          </div>
        </div>

        <div className="mb-6" data-id="element-168">
          <div className="flex justify-center items-end gap-4" data-id="element-169">
            <span className="text-3xl text-gray-400 line-through font-bold" data-id="element-170">
              39,99€
            </span>
            <motion.span key={finalTotal} initial={{
            scale: 1.15
          }} animate={{
            scale: 1
          }} className="text-6xl font-black text-gray-800" data-id="element-171">
              {finalTotal.toFixed(2).replace('.', ',')}€
            </motion.span>
          </div>
        </div>

        <Button size="lg" href={checkoutUrl} className="w-full md:w-auto text-xl py-6 px-12 animate-pulse hover:animate-none shadow-glow" data-id="element-172">
          ¡SÍ, QUIERO MI KIT AHORA!
        </Button>

        {/* Trust Badge */}
        <div className="mt-4 flex justify-center" data-id="element-173">
          <img src="https://cdn.magicpatterns.com/uploads/fKX1A96N7bu4Mq2eKUTuAa/Captura_de_pantalla_2026-04-21_190646.png" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, PayPal" className="h-12 md:h-14 object-contain" data-id="element-174" />
        </div>

        {/* Order Bumps */}
        <div className="mt-10 flex flex-col gap-4 text-left" data-id="element-175">
          <motion.h4 animate={{
          y: [0, -6, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'easeInOut'
        }} className="font-black text-lg text-partyPink-hot text-center mb-2 flex items-center justify-center gap-2" data-id="element-176">
            <span className="text-2xl" data-id="element-177">👇</span>
            ¡Añade estos complementos a tu pedido!
            <span className="text-2xl" data-id="element-178">👇</span>
          </motion.h4>
          {orderBumps.map((bump, idx) => {
          const isSelected = selectedBumps[idx];
          return <div key={idx} onClick={() => toggleBump(idx)} className={`relative rounded-2xl border-2 cursor-pointer transition-all overflow-hidden ${isSelected ? 'border-partyPink-hot bg-partyPink-light/30' : 'border-gray-200 bg-white hover:border-partyPink-light'}`} data-id="element-179">
                {bump.recommended && <div className="bg-yellow-party text-gray-800 text-xs font-bold px-4 py-1.5 text-center border-b border-yellow-400" data-id="element-180">
                    ⭐ RECOMENDADA
                  </div>}
                <div className="flex gap-4 p-4" data-id="element-181">
                  {/* Checkbox + Image */}
                  <div className="flex flex-col items-center gap-2 flex-shrink-0" data-id="element-182">
                    <input type="checkbox" checked={!!isSelected} onChange={() => {}} className="w-5 h-5 accent-partyPink-hot cursor-pointer" data-id="element-183" />
                    <img src={bump.image} alt={bump.title} className="w-32 h-32 md:w-36 md:h-36 object-cover rounded-xl shadow-sm" data-id="element-184" />
                  </div>
                  {/* Content + Price */}
                  <div className="flex flex-col justify-between flex-grow min-w-0" data-id="element-185">
                    <div data-id="element-186">
                      <h4 className="font-bold text-gray-800 text-sm md:text-base leading-tight mb-1" data-id="element-187">
                        {bump.title}
                      </h4>
                      <p className="text-xs md:text-sm text-gray-600 leading-snug" data-id="element-188">
                        {bump.desc}
                      </p>
                    </div>
                    <div className="flex items-center gap-2 mt-2" data-id="element-189">
                      <span className="text-xs text-gray-400 line-through" data-id="element-190">
                        {bump.strike}
                      </span>
                      <span className="font-black text-partyPink-hot text-base md:text-lg" data-id="element-191">
                        +{bump.price.toString().replace('.', ',')}€
                      </span>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Second Buy Button with dynamic price */}
        <div className="mt-8 text-center" data-id="element-192">
          <div className="mb-3" data-id="element-193">
            <span className="text-2xl font-black text-gray-800" data-id="element-194">
              Total: {finalTotal.toFixed(2).replace('.', ',')}€
            </span>
          </div>
          <Button size="lg" href={checkoutUrl} className="w-full md:w-auto text-xl py-6 px-12 animate-pulse hover:animate-none shadow-glow" data-id="element-195">
            ¡SÍ, QUIERO MI KIT AHORA!
          </Button>
          {/* Trust Badge */}
          <div className="mt-4 flex justify-center" data-id="element-196">
            <img src="https://cdn.magicpatterns.com/uploads/fKX1A96N7bu4Mq2eKUTuAa/Captura_de_pantalla_2026-04-21_190646.png" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, PayPal" className="h-12 md:h-14 object-contain" data-id="element-197" />
          </div>
        </div>

        {/* Garantía destacada */}
        <div className="mt-10 bg-mint-light rounded-2xl p-6 border-2 border-mint-dark relative text-left" data-id="element-198">
          <div className="absolute -top-5 right-6 bg-white rounded-full p-2 shadow-md" data-id="element-199">
            <ShieldCheck className="w-8 h-8 text-mint-dark" data-id="element-200" />
          </div>
          <h4 className="font-black text-xl text-gray-800 mb-2" data-id="element-201">
            🛡️ Garantía Total de Satisfacción
          </h4>
          <p className="text-gray-600 font-medium text-sm leading-relaxed" data-id="element-202">
            Si no quedas 100% satisfecha con tu kit, te devolvemos el dinero sin
            hacer preguntas. Además, si tienes cualquier problema técnico con
            tus archivos o no puedes editarlos, nuestro equipo de soporte te
            ayudará en menos de 24 horas. ¡Compra sin riesgo!
          </p>
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-600 font-medium" data-id="element-203">
          <div className="flex items-center gap-2" data-id="element-204">
            <ShieldCheck className="w-5 h-5 text-mint-dark" data-id="element-205" />
            <span data-id="element-206">Pago 100% Seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-207">
            <Clock className="w-5 h-5 text-mint-dark" data-id="element-208" />
            <span data-id="element-209">Acceso de por vida</span>
          </div>
        </div>
      </div>
    </Section>;
}